var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkScore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3383 19.8595L11.7301 12.0632L12.6163 6.34238L12.6059 4.90955H12.3244L12.2097 5.32043L10.1662 16.2037L7.66406 19.7647",
    stroke: "#55489E",
    strokeWidth: 1.88,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38281 10.6619L8.81114 7.64876L12.0014 5.36255L14.1283 8.755L17.3811 10.2932",
    stroke: "#55489E",
    strokeWidth: 1.88,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.9991H3.01303",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 22.9991H8.25522",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.9991H13.5026",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7422 22.9991H18.7552",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9883 22.9991H24.0013",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6239 3.45566C11.6856 3.45566 10.9141 2.67603 10.9141 1.72783C10.9141 0.779631 11.6856 0 12.6239 0C13.5622 0 14.3337 0.779631 14.3337 1.72783C14.3337 2.67603 13.5622 3.45566 12.6239 3.45566Z",
    fill: "#55489E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkScore);
export default __webpack_public_path__ + "static/media/walk-score.e4494d84.svg";
export { ForwardRef as ReactComponent };